(ns hai.ui.rf-sugar
  "Make the re-frame API more palatable."
  #?(:cljs (:require-macros [hai.ui.rf-sugar]))
  (:require
   [re-frame.core :as rf]
   #?@(:cljs [reagent.core]
       :clj [[clojure.string :as str]])))

(defn wrapv [o]
  (if (vector? o) o [o]))

(def <s (comp rf/subscribe wrapv))
(def >e (comp rf/dispatch wrapv))
(def >e! (comp rf/dispatch-sync wrapv))

#?(:clj
   (defn keyword->fn-name [kw]
     (symbol (str/replace (subs (str kw) 1) #"[/\.]" "-"))))

#?(:clj
   (defmacro defsub
     "Define a re-frame subscription more succinctly

  The basic syntax looks much like a function definition, any arguments in the
  subscription vector are bound to the symbols in the argument vector.

  (defsub :my/sub [arg]
    (:prop arg))

  (<s [:my/sub {:prop 123}])

  Subscriptions that take other subscriptions as inputs can use the <- syntax,
  to bind the output of a subscription to an argument.

  (defsub :other/sub [in <- [:my/sub 123]]
    (:other-prop in))

  The subscription vector in this case can reference earlier regular arguments

  (defsub :third/sub [id
                      entity <- [entity id]]
    (:prop entity))

  (<s [:third/sub 123])

  When using a subscription as an input that doesn't take additional arguments,
  the surrounding vector can be ommitted:

  (defsub :first-channel [channels <- :channels]
    (first channels))

  PS: arguments in defsub only supports map destructuring, but does NOT
  support vector destructuring."
     [name argv & body]
     (let [valid-binding? #(or (map? %) (symbol? %)) ;; vectors could be other subscriptions
           triples        (filter (comp valid-binding? first) (partition-all 3 1 argv))
           signals        (filter (comp #{:<- '<-} second) triples)
           argv           (map first (remove (comp #{:<- '<-} second) triples))
           inputv         (map first signals)
           input-count    (max 1 (count signals))]
       `(rf/reg-sub
         ~name
         ~@(when (seq signals)
             [`(fn [[_# ~@argv] _#]
                 [~@(for [[_ _ subv] signals]
                      `(rf/subscribe ~(if (vector? subv) subv [subv])))])])
         (fn
           ~(keyword->fn-name name)
           ~(if (seq signals)
              `[[~@inputv] [_# ~@argv]]
              `[~(first argv)  [_# ~@(rest argv)]])
           ~@body)))))

#?(:clj
   (defmacro defevent
     "Shorthand for reg-event-db. Argument vector should take db as first arg,
  followed by event vector bindings, without the surrounding vector or event
  name placeholder.

  (defevent :foo/bar [db arg] ,,,)
  (>e [:foo/bar arg])

  Use <-> to indicate an interceptor chain


  (defevent :foo/bar <-> [(inject-cofx :foo)]
     [db arg]
     ,,,)
  "
     [name argv & body]
     (let [[interceptors argv body] (if (= '<-> argv)
                                      [(first body) (second body) (rest body)]
                                      [[] argv body])]
       `(rf/reg-event-db
         ~name
         ~interceptors
         (fn ~(keyword->fn-name name)
           [~(first argv) [_# ~@(rest argv)]]
           ~@body)))))

#?(:clj
   (defmacro defevent-fx
     "Shorthand for reg-event-fx. Argument vector receives first the map with
  coeffects, followed by any arguments taken from the event vector.

  (defevent-fx :foo/bar [{:keys [db]} arg] ,,,)

  Use <-> to introduce an interceptor chain

  (defevent-fx :foo/bar <-> [my-interceptor] [{:keys [db]} arg] ,,,)
  "
     [name argv & body]
     (let [[interceptors argv body] (if (= '<-> argv)
                                      [(first body) (second body) (nnext body)]
                                      [[] argv body])]
       `(rf/reg-event-fx
         ~name
         ~interceptors
         (fn ~(keyword->fn-name name)
           [~(first argv) [_# ~@(rest argv)]]
           ~@body)))))

#?(:clj
   (defmacro defeffect
     "Shorthand for reg-fx. Argument vector receives a single argument.

     Creates an effect handler which defines side-effecting code.

         (defeffect :foo/bar [arg] ...)

     This can then be returned as an effect like so:

         {:db ...
          :foo/bar :value}
     "
     [name argv & body]
     `(rf/reg-fx
       ~name
       (fn ~(keyword->fn-name name)
         [~(first argv)]
         ~@body))))

#?(:clj
   (defmacro defcoeffect
     "Shorthand for reg-cofx. Argument vector receives first the map
     with coeffects, followed by any arguments taken from the event
     vector.

     Creates a coeffect handler for later use with
     `inject-cofx`. Return an updated `coeffects` from the body.

         (defcoeffect :foo/bar [coeffects arg] ...)

     This can then be injected like so:

         (defevent-fx :foo/event <-> [(inject-cofx :foo/bar :arg-value)]
            [...] ...)
     "
     [name argv & body]
     `(rf/reg-cofx
       ~name
       (fn ~(keyword->fn-name name)
         [~(first argv) ~@(rest argv)]
         ~@body))))

(comment
  (macroexpand-1 '(defcofx :now [coeffects _]
                    (assoc coeffects :now 10)))

  (macroexpand
   '(defsub :channel/list [db]
      (:channel/list db)))


  (macroexpand
   '(defsub :channel/list
      [foo :<- [:foo]
       bar :<- [:bar]
       baz]
      (:channel/list db)))

  (macroexpand
   '(defevent :channels/set [db channels]
      (assoc db :channel/list channels))))
